export const treatment = {
  jobs: {
    message: 'Voulez-vous relancer le job',
    change_failed: 'Voulez-vous passer le job en Failed',
    change_failed_placeholder: 'Passage en Failed',
    relance_placeholder: 'Relancer',
    header: {
      title: 'Liste des Jobs',
    },
    columns: {
      job_number: 'N° de Job',
      status: 'Statut',
      type: 'Type',
      priority: 'Priorité',
      recursive: 'Récurrent',
      date: 'Date de création',
      programmation_date: 'Programmé le',
      start_date: 'Début de traitement',
      end_date: 'Fin de traitement',
      error_code: "Code d'erreur",
      server: 'Serveur',
      description: 'Description',
    },
  },
  controle: {
    header: {
      title: 'Liste des demandes de contrôle',
      add: 'Contrôle de tiers',
    },
    columns: {
      etat: 'Etat',
      date_envoye: "Date d'envoi",
      type: 'Type',
      libelle: 'Libelle',
      login: 'Login',
      nb: 'Nb',
      ok: 'Ok',
      di: 'Diam.',
      nok: 'NOK',
      vis: 'Visualisation',
    },
    newSSid: {
      thirdG: 'Groupe de tiers',
      thirdP: 'Tiers unitaire',
      placeholder: 'Renseigner les 3 premières lettres du tiers recherché',
    },
  },
  details: {
    title: 'Liste des demandes de controle',
    fermer: 'Fermer',
    titleDrawer: 'Reason',
    columns: {
      state: 'Etat',
      code: 'Code',
      name: 'Nom',
      nCompte: 'N° Compte',
      idEnv: 'SIRET / TVA',
      typeT: 'Type tiers',
      codeP: 'Code pays',
      noteP: 'Note Analyse',
      reason: 'Reason',
      date_analyse: 'Date Demande',
    },
  },
}




